<div class="flex items-center justify-center bg-grey-lighter">
  <label class="w-64 flex flex-col items-center px-4 py-6 bg-white text-blue rounded-lg shadow-lg tracking-wide border border-blue cursor-pointer">
    <mat-icon>cloud_upload</mat-icon>
      <span class="mt-2 text-sm leading-normal">Select Image (png/jpg/jpge) Only</span>
      <input type="file" class="input-file hidden" readonly accept="image/png, image/jpg, image/jpeg" (change)="upload($event)">
  </label>
</div>
